import React from 'react';
import { createUseStyles } from 'react-jss';
import { LockFeatureChip, MenuItem } from '@app/core';
import { useTranslation } from 'react-i18next';
import { Theme } from '@app/theme';
import { Feature } from '@app/api';
import { useFeatureRequiredCallback } from 'components';
import { MenuItemProps } from '@mui/material';

const useStyles = createUseStyles((theme: Theme) => ({
  chip: {
    marginRight: theme.marginBase,
  },
}));

interface Props extends MenuItemProps {
  label?: string;
  className?: string;
  value?: any;
  button?: undefined;
  onSelect?: (val: any) => any;
  feature?: Feature;
}

export const LockableMenuItem = ({
  feature,
  onClick,
  onSelect,
  children,
  label,
  ...rest
}: Props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const onMenuClick = useFeatureRequiredCallback(feature, (e: any) => {
    if (onClick) {
      onClick(e);
    }
  });
  const onMenuSelect = useFeatureRequiredCallback(feature, (value: any) => {
    if (onSelect) {
      onSelect(value);
    }
  });

  return (
    <MenuItem
      {...rest}
      onClick={onClick ? onMenuClick : undefined}
      onSelect={onSelect ? onMenuSelect : undefined}
    >
      {feature && (
        <LockFeatureChip feature={feature} className={classes.chip} />
      )}
      {children || label}
    </MenuItem>
  );
};
